import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { GordonLandRoot } from "./gordonland-root.js";
import "./styles.css";

const rootElement = document.querySelector("#root");

if (rootElement === null) throw new Error("GordonLand root element is missing");

createRoot(rootElement).render(
  <StrictMode>
    <GordonLandRoot />
  </StrictMode>,
);
